<template>
  <admin-wrapper title-translation-path="admin.MASTERPLAN_STREETS" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers scope="masterplan_streets" class="pt-8" schema_scope="masterplan_streets" :tab-prop="tab" />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'MasterplanStreetsSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'masterplan_streets_module_enabled',
        translationPath: 'admin.MASTERPLAN_STREETS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', {
          suffix: this.$i18n.t('admin.MASTERPLAN_STREETS'),
        }),
      };
    },
  },
};
</script>
